/**
 * Persist Dalle image outputs using IndexedDB to avoid localStorage quota limits.
 * Uses the same key names as localStorage (e.g. mission-dalle-outputs) for consistency.
 */

const DB_NAME = "DalleOutputsDB";
const STORE_NAME = "outputs";
const DB_VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(req.error);
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

export function getDalleOutputs(storageKey) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readonly");
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(storageKey);
      req.onerror = () => reject(req.error);
      req.onsuccess = () => resolve(req.result ?? null);
    });
  });
}

export function setDalleOutputs(storageKey, outputs) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      const store = tx.objectStore(STORE_NAME);
      const req = store.put(outputs, storageKey);
      req.onerror = () => reject(req.error);
      req.onsuccess = () => resolve();
    });
  });
}

export function clearDalleOutputs(storageKey) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      const store = tx.objectStore(STORE_NAME);
      const req = store.delete(storageKey);
      req.onerror = () => reject(req.error);
      req.onsuccess = () => resolve();
    });
  });
}
